/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { Injectable } from "@jack-henry/frontend-utils/di";
import { TmHttpClient } from "@treasury/core/http";
import { createSwaggerClient } from "../../utils/tm-swagger-client";

import { WireCompanyModelDto } from "../";
import { HttpClient, RequestParams } from "./http-client";

@Injectable()
export class WireCompaniesClient {
  private readonly http: HttpClient;

  constructor(tmHttp: TmHttpClient) {
    this.http = createSwaggerClient(tmHttp, HttpClient);
  }

  /**
   * No description
   *
   * @tags WireCompanies
   * @name WireCompaniesGet
   * @summary Search for Wire Companies for passed criteria with an int-based company identifier.
   * @request GET:/WireCompanies/{id}/search
   */
  wireCompaniesGet = (
    id: number,
    query: {
      /** Contains search on Company Name */
      companyName: string | null;
      isDli: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<WireCompanyModelDto[], any>({
      path: `/WireCompanies/${id}/search`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags WireCompanies
   * @name WireCompaniesGet2
   * @summary Search for Wire Companies for passed criteria with a GUID-based company identifier.
   * @request GET:/WireCompanies/{companyGuidUniqueId}/searchByUniqueId
   */
  wireCompaniesGet2 = (
    companyGuidUniqueId: string,
    query: {
      /** Contains search on Company Name */
      companyName: string | null;
      isDli: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<WireCompanyModelDto[], any>({
      path: `/WireCompanies/${companyGuidUniqueId}/searchByUniqueId`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags WireCompanies
   * @name WireCompaniesAccounts
   * @summary Return accounts for specified wire company Id
   * @request GET:/WireCompanies/accounts
   */
  wireCompaniesAccounts = (
    query: {
      /** Core Company Id */
      coreCompanyId: string | null;
      /**
       * Parent CompanyId
       * @format int32
       */
      parentCompanyId: number;
      isDli: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<WireCompanyModelDto, any>({
      path: `/WireCompanies/accounts`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags WireCompanies
   * @name WireCompaniesAccounts2
   * @summary Return accounts for specified wire company using the company guid unique id.
   * @request GET:/WireCompanies/{companyGuidUniqueId}/accounts
   */
  wireCompaniesAccounts2 = (
    companyGuidUniqueId: string,
    query: {
      /** Core Company Id */
      coreCompanyId: string | null;
      isDli: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<WireCompanyModelDto, any>({
      path: `/WireCompanies/${companyGuidUniqueId}/accounts`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
}
